module.exports = __webpack_public_path__ + "static/media/mk2_ang.0d0467b9.png";